import { Cleavage } from '../../../domain/entities/Cleavage';
import { BACKEND_API_URL } from '../../../api/Backend_API_URL';
export class AxiosGlobalCleavageDrawPileGateway {
    constructor(axiosBackendInstance) {
        this.axiosBackendInstance = axiosBackendInstance;
    }
    retrieveCleavageDrawpileQuantity() {
        return this.axiosBackendInstance.axiosInstance.get(BACKEND_API_URL.GLOBAL_CLEAVAGE_DRAWPILE_QUANTITY)
            .then(response => Promise.resolve(parseInt(response.data)))
            .catch(error => Promise.reject(error));
    }
    drawGlobalCleavage() {
        return this.axiosBackendInstance.axiosInstance.get(BACKEND_API_URL.GLOBAL_CLEAVAGE_DRAWPILE_DRAW)
            .then(response => Promise.resolve(response.data ? new Cleavage(response.data) : undefined))
            .catch(error => Promise.reject(error));
    }
    save(cleavage) {
        return this.axiosBackendInstance.axiosInstance.post(BACKEND_API_URL.GLOBAL_CLEAVAGE_DRAWPILE_SAVE, cleavage)
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    }
}
